import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const accordionHeaderStyle = css`
  & .header-container {
    justify-content: space-between;
    align-items: center;
  }
`;

export const headerIconStyle = css`
  font-weight: ${theme.font.weight.bold};
`;

export const selectionBadgeStyle = css`
  background-color: ${theme.colors.primary10};
  color: ${theme.colors.neutral90};
  border-radius: ${theme.borderRadius.small};
  font-size: ${theme.fontSize(12)};
  font-weight: ${theme.font.weight.bold};
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing(0, 0.5)};
`;

export const accordionBodyStyle = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
`;

export const selectActionsRowStyle = css`
  display: flex;
  justify-content: space-between;
`;

export const clearActionsRowStyle = css`
  display: flex;
  justify-content: flex-end;
`;

export const emptyMessageStyle = css`
  padding: ${theme.spacing(2)};
  text-align: center;
  color: ${theme.colors.neutral50};
`;

export const scrollFieldStyle = css`
  max-height: 200px;
  overflow-y: auto;
`;

export const checklistOptionStyle = css`
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0;
  cursor: pointer;
  border-radius: ${theme.borderRadius.small};
  align-items: center;

  & > label {
    flex: 1;
    cursor: pointer;
    padding: ${theme.spacing(1)};
    margin-top: 0;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  & > div {
    margin: ${theme.spacing(1, 0, 1, 1)};
  }
`;
